import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import OperatorApplicationDialogTextareaAction
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaAction.vue";
import useTextareaComponent from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "ReplyTo"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {model, setReplyToMessageId} = useTextareaComponent();

return (_ctx: any,_cache: any) => {
  return (_unref(model).replyTo)
    ? (_openBlock(), _createBlock(OperatorApplicationDialogTextareaAction, {
        key: 0,
        icon: "reply",
        "cancel-listening": "",
        onCancel: _cache[0] || (_cache[0] = ($event: any) => (_unref(setReplyToMessageId)(null))),
        class: "pr-3"
      }, {
        title: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Ответ: ", -1)
        ]))]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_unref(model).replyTo.textPreview), 1)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})